import {SelectMediaSheet} from '@cohort/merchants/apps/common/triggers/SelectMedia/SelectMediaSheet';
import {
  SelectMediaSheetCards,
  SelectMediaSheetCardsGroup,
  SelectMediaSheetPanel,
  SelectMediaSheetSearchInput,
} from '@cohort/merchants/apps/common/triggers/SelectMedia/SelectMediaSheet';
import {groupMediasByMonth} from '@cohort/merchants/apps/common/triggers/utils';
import YoutubeVideoCard from '@cohort/merchants/apps/youtube/triggers/YoutubeVideoCard';
import type {YoutubeVideo} from '@cohort/shared/apps/youtube/common';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

type SelectVideoSheetProps = {
  videos: YoutubeVideo[];
  onSelect: (mediaId: string) => void;
};
const SelectVideoSheet: React.FC<SelectVideoSheetProps> = ({videos, onSelect}) => {
  const {t} = useTranslation('app-youtube', {
    keyPrefix: 'components.selectVideoSheet',
  });

  const [searchQuery, setSearchQuery] = useState('');

  const filteredVideos = videos.filter(video =>
    video.title.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const mediasByMonth = groupMediasByMonth(filteredVideos, media => media.publishedAt);

  return (
    <SelectMediaSheet onSubmit={onSelect} title={t('title')}>
      <SelectMediaSheetSearchInput searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      <SelectMediaSheetPanel isEmpty={filteredVideos.length === 0}>
        {Array.from(mediasByMonth).map(([month, medias]) => (
          <SelectMediaSheetCardsGroup label={month} key={month}>
            <SelectMediaSheetCards medias={medias} Card={YoutubeVideoCard} />
          </SelectMediaSheetCardsGroup>
        ))}
      </SelectMediaSheetPanel>
    </SelectMediaSheet>
  );
};

export default SelectVideoSheet;
